// extracted by mini-css-extract-plugin
export default {"scenario":"PFQuiz_scenario__PmI-r","optionRow":"PFQuiz_optionRow__tpXQt","optionGrayed":"PFQuiz_optionGrayed__pNYeu","submitButton":"PFQuiz_submitButton__dp1Mn"};